import { useEffect } from "react"
import { Bound } from "lib/@components/binding/Bound"
import { If, Else } from "lib/@components/switch"
import { ShowActivity } from "routes/@lib/activity/activity.runtime"
import { NotOnMobile } from "lib/@components/mobile"
import { Loader } from "lib/@components/Loader"
import { AuditLog } from "./audit-log"
import { AuditTopBar } from "./top-bar"
import { getAuditsForTypeAllClients } from "../controller/get-all-audits-for-type"
import { getAuditsByReferenceIdAndType } from "../controller/get-audits-by-reference-id"
import { getApprovedChanges } from "../controller/get-approved-changes"

/**
 * The standard activity log: fetches the full audit set in one query and renders it. Used for all
 * activity logs except those that opt into incremental loading via `pageSize` (see AuditContainer).
 */
export function DefaultAuditContainer({
    setOpen,
    type,
    id,
    forTypeAllClients,
    fileNamePrefix,
    filterFn,
    auditLogData,
    isDialog,
    published = false,
    filter,
    getAuditsFn = getAuditsByReferenceIdAndType,
    additionalParams = [],
}) {
    const { loading, data } = forTypeAllClients
        ? getAuditsForTypeAllClients.useResults.status(type)
        : published
          ? getApprovedChanges.useResults.status(id, type)
          : getAuditsFn.useResults.status(id, type, filter, ...additionalParams)

    useEffect(() => {
        if (data && !auditLogData?.data) {
            const combinedData = { ...auditLogData, data }
            ShowActivity.raise(combinedData)
        }
    }, [data, auditLogData?.data, auditLogData])

    if (loading) return <Loader inline color="primary" />

    return (
        <Bound data={data} loadingData={loading} auditId={id} type={type}>
            <If value={isDialog}>
                <AuditTopBar setOpen={setOpen} type={type} fileNamePrefix={fileNamePrefix} filterFn={filterFn} />
                <Else>
                    <NotOnMobile>
                        <AuditTopBar
                            setOpen={setOpen}
                            type={type}
                            fileNamePrefix={fileNamePrefix}
                            filterFn={filterFn}
                        />
                    </NotOnMobile>
                    <AuditLog setOpen={setOpen} />
                </Else>
            </If>
        </Bound>
    )
}
